import { createRouter, createWebHistory } from 'vue-router'
import ChooseCompany from '../views/ChooseCompany.vue'
import SetCompany from '../views/SetCompany.vue'
import RunFirst from '../views/RunFirst.vue'




//import {log} from '@/utils.js'


const routes = [
  {
    path: '/',
    name: 'home',
    component: ChooseCompany,
  },
  {
    path: '/run/:id?/:api_key?',
    name: 'run',
    component: RunFirst,
  },
  {
    path: '/set',
    name: 'set',
    component: SetCompany,
  },
]


const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
